<template>
  <div class="panel panel-gray wraper" v-if="tree[0]">
    <div class="panel-header" v-if="tree.length > 10">
      <q-input
          name="filter"
          v-model="filter"
          float-label="&#128269; в названии"
          clearable
          style="width: 400px;"
      />
    </div>
    <div class="panel-group" :class="{scroll: $route.meta.showLeft}">
      <q-tree
          :nodes="tree"
          node-key="key"
          :selected.sync="selected"
          :filter="filter"
          text-color="primary"
      >
        <div slot="header-variant" slot-scope="prop">
          <q-icon class="q-tree-icon" name="fas fa-file-alt" />
          <q-icon class="q-tree-icon q-mr-sm" name="far fa-file-alt" color="warning"/>
          <span>{{ prop.node.label }}</span>
        </div>
        <div slot="header-draft" slot-scope="prop">
          <q-icon class="q-tree-icon q-mr-sm" name="far fa-file-alt" color="warning"/>
          <span class="text-warning">{{ prop.node.label }}</span>
        </div>
        <div slot="header-disabled" slot-scope="prop" class="cursor-not-allowed">
          <q-icon class="q-tree-icon q-mr-sm" name="fas fa-file-alt" color="light"/>
          <span class="text-light">{{ prop.node.label }}</span>
        </div>
      </q-tree>
      <q-btn
          v-back-to-top.animate="500"
          round
          color="teal-5"
          class="fixed-bottom-left"
          style="margin: 0 0 15px 15px"
      >
        <q-icon name="keyboard_arrow_up" />
      </q-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  // components: { Tree, QSearch },
  name: 'treeWiki',
  props: {
    base: {
      type: String,
      default: 'root',
    },
    withDraft: {
      type: Boolean,
      default: true,
    },
    done: {
      type: Function,
    },
    disabledNode: {
      type: String,
    },
    disabledNotExpandable: {
      type: Boolean,
    },
  },
  data() {
    return {
      filter: '',
    };
  },
  methods: {
  },
  computed: {
    ...mapGetters({
      subTree: 'wiki/subTree',
    }),
    tree() {
      return this.subTree(this.base, this.withDraft, this.disabledNode, this.disabledNotExpandable ? this.disabledNode : null);
    },
    selected: {
      get() {
        console.log('this.$route.params', this.$route.params);
        if (!this.done && this.$route.params.fullId) {
          return this.$route.params.fullId.replace('v:', 'a:');
        }
        return null;
      },
      set(newValue) {
        if (newValue) {
          if (this.done) {
            if (newValue !== this.disabledNode) {
              this.done(newValue);
              return;
            }
          } else {
            this.$router.push(`/wiki/${newValue}`);
            return;
          }
        }
        console.log('oops!'); // if click on already selected or disabled item
      },
    },
  },
  watch: {
  },
};
</script>

<style lang="stylus">
  .my-padding
    padding 1rem 1rem
    margin auto
</style>



// WEBPACK FOOTER //
// src/components/tree-wiki.vue